import { AppConfig } from "../app/config";
import noImg from '../assets/images/no-image.webp';

interface Props {
    data: any;
    stylesData: string;
}
export const ProductView = (props: Props) => {
    return <>{props.data && props.data.map((value: any, index: any) => (
        <div className={props.stylesData} key={index}>
            <div className="card border-0 rounded-4 box-shadow h-100">
                <div className='card-body p-2'>
                    <div className="row align-items">
                    <img src={value.product_image ? `${AppConfig.IMAGE_PATH}${value.product_image}` : noImg} alt="product" height={90}  className="col-3 object-fit-contain"/>
                    <div className="col-9 ps-0"><h6 className='mt-1 fs-14'>{value.product_name}</h6>
                    <div className="fs-14 d-flex justify-content-between align-items"><div><b>Quantity :</b> {value?.quantity}</div><h6 className="mb-0 fs-14"><b>Total :</b>₹ {value.total || value?.product_amount_total}</h6></div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    ))}
    </>
    
} 